import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { authInterceptor, provideAuth } from '@rind/auth';
import { provideDismissOnOutside, provideTheme } from '@rind/ui';

import { routes } from './app.routes';
import { apiBaseUrlInterceptor } from './core/api/api-base.interceptor';
import { INVENTORY_APPLICATION } from './core/api/models';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideTheme({ storageKey: 'inventory.web.theme' }),
    provideDismissOnOutside(),
    provideAuth({
      application: INVENTORY_APPLICATION,
      sessionMetaKey: 'inventory.web.session.meta',
      legacySessionKey: 'inventory.web.session',
      apiBaseUrl: environment.platformApiBaseUrl,
    }),
    provideHttpClient(withInterceptors([apiBaseUrlInterceptor, authInterceptor])),
    provideRouter(routes),
  ],
};
